import { api } from "../../Lib/constants"
import { getAuthHeader } from "../../Lib/utils"
import { ADD_INTERNALTRANSACTION, ADD_INTERNALTRANSACTION_FAILURE, ADD_INTERNALTRANSACTION_SUCCESS, ADD_TRANSACTION, ADD_TRANSACTION_FAILURE, ADD_TRANSACTION_SUCCESS, ADD_TRANSACTIONTOCSV, ADD_TRANSACTIONTOCSV_SUCCESS, ADD_TRANSACTIONTOCSV_FAILURE, INTERNAL_TRANSACTION, INTERNAL_TRANSACTION_FAILURE, INTERNAL_TRANSACTION_SUCCESS, SINGLE_TRANSACTION, SINGLE_TRANSACTION_FAILURE, SINGLE_TRANSACTION_SUCCESS, TRANSACTION, TRANSACTION_FAILURE, TRANSACTION_SUCCESS, UPDATEINTERNALTRANSACTION, UPDATEINTERNALTRANSACTION_FAILURE, UPDATEINTERNALTRANSACTION_SUCCESS, UPDATETRANSACTION, UPDATETRANSACTION_FAILURE, UPDATETRANSACTION_SUCCESS } from "./actionTypes"
import { toast } from "react-toastify";

export const getAllTransactions = (params = "") => async dispatch => {
    dispatch({
        type: TRANSACTION
    })
    try {
        let response = await api(`transactions/all${params}`, 'get', {}, getAuthHeader());
        console.log('transactions data', response);
        dispatch({
            type: TRANSACTION_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("Fetching Error while Transactions =====>", error);
        return Promise.reject(dispatch({
            type: TRANSACTION_FAILURE,
            payload: error?.message
        }))
    }
}
export const getAllInternalTrans = (params) => async dispatch => {
    dispatch({
        type: INTERNAL_TRANSACTION
    })
    try {
        let response = await api(`transactions/allInternal${params}`, 'get', {}, getAuthHeader());
        console.log('transactions data', response);
        dispatch({
            type: INTERNAL_TRANSACTION_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("Fetching Error while Transactions =====>", error);
        return Promise.reject(dispatch({
            type: INTERNAL_TRANSACTION_FAILURE,
            payload: error?.message
        }))
    }
}
export const getSingleTransactions = (id) => async dispatch => {
    dispatch({
        type: SINGLE_TRANSACTION
    })
    try {
        let response = await api(`transactions/transaction/${id}`, 'get', {}, getAuthHeader());
        console.log('transactions Details===>', response);
        dispatch({
            type: SINGLE_TRANSACTION_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("Fetching Error while Transactions =====>", error);
        return Promise.reject(dispatch({
            type: SINGLE_TRANSACTION_FAILURE,
            payload: error?.message
        }))
    }
}

export const addTransaction = (data) => async dispatch => {
    dispatch({
        type: ADD_TRANSACTION
    })
    try {
        const response = await api('transactions/add', "post", data, getAuthHeader())
        console.log("add Transaction success response is ===>", response);
        response && toast.success("Added Successfully");

        dispatch({
            type: ADD_TRANSACTION_SUCCESS,
            payload: response
        })
    } catch (error) {
        console.log("Fetching Error while Add Transaction =====>", error);
        toast.error(error?.message);
        return Promise.reject(dispatch({
            type: ADD_TRANSACTION_FAILURE,
            payload: error?.message
        }))
    }
}

export const importCSV = (file, data) => async (dispatch) => {
    dispatch({
        type: ADD_TRANSACTIONTOCSV
    });

    try {

        const fileName = file.name;
        const response = await api('transactions/importCSV', "post", { fileName, data }, getAuthHeader());

        toast.success('Transactions from csv file added successfully', {
            autoClose: 3000,
        });
        dispatch({
            type: ADD_TRANSACTIONTOCSV_SUCCESS,
            payload: response
        });

    } catch (error) {
        console.error('Error formatting data to CSV:', error);
        toast.error(error?.response?.data?.error || error?.message);
        return Promise.reject(dispatch({
            type: ADD_TRANSACTIONTOCSV_FAILURE,
            payload: error?.message
        }))

    }
};


export const addInternalTransaction = (data) => async dispatch => {
    dispatch({
        type: ADD_INTERNALTRANSACTION
    })
    try {
        const response = await api('transactions/addInternal', "post", data, getAuthHeader())
        console.log("add Transaction success response is ===>", response);
        response && toast.success("Added Successfully");
        dispatch({
            type: ADD_INTERNALTRANSACTION_SUCCESS,
            payload: response
        })
    } catch (error) {
        console.log("Fetching Error while Add Transaction =====>", error);
        toast.error(error?.message);
        return Promise.reject(dispatch({
            type: ADD_INTERNALTRANSACTION_FAILURE,
            payload: error?.message
        }))
    }
}

export const updateTransaction = (data, id) => async dispatch => {
    dispatch({
        type: UPDATETRANSACTION
    })
    try {
        const response = await api(`transactions/update/${id}`, "put", data, getAuthHeader())
        console.log("update Transaction success response is ===>", response);
        response && toast.success("Updated SuccessFully");
        dispatch({
            type: UPDATETRANSACTION_SUCCESS,
            payload: response
        })
    } catch (error) {
        console.log("Fetching Error while update Transaction =====>", error);
        toast.error(error?.message);
        return Promise.reject(dispatch({
            type: UPDATETRANSACTION_FAILURE,
            payload: error?.message
        }))
    }
}

export const updateInternalTransaction = (data, id) => async dispatch => {
    dispatch({
        type: UPDATEINTERNALTRANSACTION
    })
    try {
        const response = await api(`transactions/updateInternal/${id}`, "put", data, getAuthHeader())
        console.log("update Transaction success response is ===>", response);
        response && toast.success("Updated SuccessFully");
        dispatch({
            type: UPDATEINTERNALTRANSACTION_SUCCESS,
            payload: response
        })
    } catch (error) {
        console.log("Fetching Error while update Transaction =====>", error);
        toast.error(error);
        return Promise.reject(dispatch({
            type: UPDATEINTERNALTRANSACTION_FAILURE,
            payload: error?.message
        }))
    }
}

